module.exports = __webpack_public_path__ + "img/140.4.71820791.png";